<template>
  <div class="product-service-section-container">
      <section-title :text="title"/>
      <div class="section-main">
          <div v-for="data in dataList" :key="data.name" :class="'cls-item'">
              <div class="item-one-row">
                  <img class="item-img" :src="data.source">
              </div>
              <div class="item-name">{{data.name}}</div>
              <div class="item-content">{{data.describe}}</div>
              <a class="item-link"  :href="data.link" target="_blank">了解详情</a>
            </div>
      </div>
  </div>
</template>

<script>
import sectionTitle from "../../components/sectionTitle.vue";
export default {
name: "LearnMaterials",
components: {
  sectionTitle
},
props: {
  title: {
    type: String,
    default: "满满干货，免费获取"
  }
},
data() {
  return {
    dataList:[
          {
          name: "京洞察|新品孵化中心 趋势洞察报告集",
          source:'//img10.360buyimg.com/img/jfs/t1/233131/32/36028/18691/6760e2ebF6255f450/6d8b42fbf60803d7.jpg',
          link:'https://jzt.jd.com/school/course/detail?contentId=15930&channelIds=1749',
          describe:
            "京洞察|新品孵化中心，联合京东研究院、行业头部品牌、行业专业咨询公司，多方打造行业趋势洞察报告、用户消费趋势报告等，为产品创新、品牌发展规划提供数智指引。"
          },
          {
          name: "京东营销云白皮书",
          source:'//img10.360buyimg.com/img/jfs/t1/247892/10/25227/29436/673d84aeF3dc04e4d/dafae5b6aef59b91.jpg',
          link:'https://mp.weixin.qq.com/s/b9UtTEafqgdDB0g6sBSJsw',
          describe:
            "联动京东数据激活品牌一方数据，通过丰富用户洞察模型和便捷策略配叠，完成消费者多维度洞察分析，实现全域精准再营销。"
          },
          {
          name: "京东消息类产品白皮书",
          source:'//img10.360buyimg.com/img/jfs/t1/240924/22/11694/26601/673d84bdFd1d13751/51eb593b7dcb3913.jpg',
          link:'https://jzt.jd.com/school/course/detail?contentId=14340&channelIds=1749',
          describe:
            "通过公私域用户精准圈选，京东站内外多触点组合触达，大促及日常多场景覆盖，投前、投中、投后全链路赋能，智能构建短信营销效果增强回路。"
          }
    ],
    active:0
  }
},
methods: {
}
};
</script>

<style lang="scss" scoped>
.product-service-section-container {
width: 100%;
padding: 80px 0 16px;
background: linear-gradient(180deg, rgba(240, 242, 255, 1) 0%, rgba(251, 252, 255, 1) 48.13%, rgba(255, 255, 255, 1) 100%);

.section-main {
  width: 1268px;
  margin: 60px auto 0;
  display: flex;
  justify-content: center;
  margin-bottom: 127px;
  .gap36 {
    padding: 0 36px;
  }
  .gap24 {
    padding: 0 24px;
  }
  .cls-item {
    width: 384px;
    height:500px;
    border-radius: 4px;
    background: #FFFFFF;
    box-shadow: 1px 5px 24px #EEEEEE;
    margin-right: 32px;
    cursor:pointer;
    .cls-img {
      width: 128px;
      height: 107px;
      display: block;
      margin: 0 auto;
    }
    .item-name {
        line-height: 22px;
        font-size: 20px;
        font-weight: 500;
        color: #000;
        margin-left: 38px;
        margin-top: 38px;
      }
    .item-one-row {
      margin-top: 0px;
      .item-img{
        width: 384px;
      }

      .cls-img-icon {
        width: 21px;
        height: 16px;
        background-size: cover;
        background-position: 50%;
        background-image: url(//img10.360buyimg.com/img/jfs/t1/87751/4/18584/1023/614c3b5aE7136004e/983857006a403af9.png);
      }
    }

    .item-content {
      font-size: 14px;
      font-weight: 400;
      color: #888;
      width: 308px;
      margin: 21px auto 32px;
    }
    .item-link{
      color: #3247FF;
      font-size: 14px;
      margin-bottom:28px;
      margin-left: 37px;
      cursor: pointer;
    }
  }
  .cls-item:hover {
    box-shadow: 1px 5px 24px rgba(144, 153, 209, 0.6);
  }
}
}
</style>

